export default "__VITE_ASSET__CTllnkU1__"